var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Banner',{attrs:{"bannerImg":_vm.$store.getters.getUrl('yc_banner')}}),_c('Downbtn'),_c('Xianlu'),_c('Games')],1)}
var staticRenderFns = []

export { render, staticRenderFns }